'use client';
import { NotFound } from '@app/components/templates/not-found';

export default function NotFoundPage() {
    return <NotFound />;
}
